/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/LoadingScreen',['pixi', 'absolute', 'lodash', 'absolute/stringmanager', 'Managers/ScaleManager', 'util/NineSliceButton'],

    function (PIXI, Absolute, _, _s, ScaleManager, NineSliceButton) {

        var LoadingScreen = function (ui) {
            this.initLoadingScreen(ui);
        };

        LoadingScreen.prototype = Object.create(Absolute.Screen.prototype);

        LoadingScreen.prototype.initLoadingScreen = function (ui) {

            PIXI.DisplayObjectContainer.call(this);

            this.ui = ui;
            var background = new PIXI.Graphics();

            background.beginFill(0x0f366a);
            background.drawRect(0, 0, 10000, 10000);
            background.endFill();
            background.interactive = true;
            background.buttonMode = true;
            background.hitArea = new PIXI.Rectangle(0, 0, this.ui.width, this.ui.height);
            Absolute.SpriteUtils.bindInteraction(background, function () {
            });
            background.mouseup = function () {
            };
            this.addChild(background);

            this.spinner = Absolute.SpriteUtils.loadMovieClip('solitaire loading00', 30, 1);
            this.spinner.loop = true;
            this.spinner.animationSpeed = 0.5;

            this.spinner.scale.set(1);
            this.addChild(this.spinner);

            this.loadingTextStyle = {
                font: Absolute.ScreenMetrics.getResScale() * 55 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 250
            };

            var loadingText = new PIXI.Text(_s('loading'), this.loadingTextStyle);
            loadingText.anchor.set(0.5, 0);
            this.loadingText = loadingText;
            this.addChild(loadingText);
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
        };

        LoadingScreen.prototype.show = function (isSplash) {
            this.spinner.play();
            this.visible = true;
            this.handleResize();

            if (isSplash) {
                this.longLoadTimeout = window.setTimeout(function () {
                    // if its taking too long to load switch to the spinner/loading screen look
                    this.show(false);
                }.bind(this), 4000);
            }
        };

        LoadingScreen.prototype.hide = function () {
            this.spinner.gotoAndStop(0);
            this.visible = false;
            window.clearTimeout(this.longLoadTimeout)
        };

        LoadingScreen.prototype.start = function () {
            this.show();
            this.spinner.gotoAndStop(0);            

            var labelOptions = {
                font: Absolute.ScreenMetrics.getResScale() * 29 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left',
                anchor: {
                    x: 0.5,
                    y: 0.5
                },
                x: Absolute.Coords.x(0),
                y: Absolute.Coords.y(3)
            };

            this.loadingText.visible = false;
        };

        LoadingScreen.prototype.resetLoadingProgress = function () {
            //
        };

        LoadingScreen.prototype.finishLoadingProgress = function () {
            //
        };

        LoadingScreen.prototype.updateLoadingProgress = function (percent) {
            Absolute.Debug.log('loading ', percent);
        };

        LoadingScreen.prototype.onShow = function () {
            Absolute.Screen.prototype.onShow.call(this);
        };

        LoadingScreen.prototype.onHide = function () {
            Absolute.Screen.prototype.onHide.call(this);
        };

        LoadingScreen.prototype.handleResize = function () {
            this.scale.set(1 / (ScaleManager.scaleFactorX), 1 / (ScaleManager.scaleFactorY));
            this.resizeSpinner();
            this.resizeLoadingText();
        };

        LoadingScreen.prototype.resizeSpinner = function () {
            this.spinner.y = (Absolute.Coords.y(ScaleManager.height) - this.spinner.height) / 2;
            this.spinner.x = (Absolute.Coords.x(ScaleManager.width) - this.spinner.width) / 2;
        };

        LoadingScreen.prototype.resizeLoadingText = function () {
            this.loadingText.y = this.spinner.y - this.loadingText.height - Absolute.Coords.x(5);
            this.loadingText.x = this.spinner.x + this.spinner.width / 2;
        };

        LoadingScreen.prototype.resizeText = function (width, height, letterStyle) {
            var font = _s.extractNumbersFromString(letterStyle.font);
            if (this.loadingText.width > width || this.loadingText.height > height) {
                _s.shrinkToFit(
                    this.loadingText,
                    font,
                    '',
                    width,
                    height
                );
            } else {
                _s.enlargeText(
                    this.loadingText,
                    font,
                    '',
                    width,
                    height
                );
            }
        };

        return LoadingScreen;

    });

